module.exports = __webpack_public_path__ + "media/images/common-nav/free-camping/utah-7ffb9575d853ffb119e2d336196aaa16.jpg";